import { setCookie, getCookieValue } from './cookie';

function toggleCookieBanner() {
  const cookieBanner = document.getElementById('cookie-banner');
  const heroSection = document.querySelector('.hero');
  const EUROPEAN_COUNTRY_CODES = [
    'AL',
    'AD',
    'AT',
    'BY',
    'BE',
    'BA',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'EL',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IS',
    'IE',
    'IT',
    'LV',
    'LI',
    'LT',
    'LU',
    'MT',
    'MD',
    'MC',
    'ME',
    'NL',
    'MK',
    'NO',
    'PL',
    'PT',
    'RO',
    'RU',
    'SM',
    'RS',
    'SK',
    'SI',
    'ES',
    'SE',
    'CH',
    'TR',
    'UA',
    'GB',
    'UK',
  ];

  if (
    window.siteInfo
    && EUROPEAN_COUNTRY_CODES.includes(window.siteInfo.country)
    && cookieBanner
  ) {
    if (!getCookieValue('isCookieBannerClosed')) {
      document
        .getElementById('cookie-banner-close')
        .addEventListener('click', () => {
          heroSection.classList.add('adjust-height');
          cookieBanner.classList.remove('show');
          setCookie('isCookieBannerClosed', true, 365);
        });
      cookieBanner.classList.add('show');
    } else heroSection.classList.add('adjust-height');
  }
}

export default toggleCookieBanner;
